import { render, staticRenderFns } from "./ThankYouDemo.vue?vue&type=template&id=2b946c4f&scoped=true&"
import script from "./ThankYouDemo.vue?vue&type=script&lang=ts&"
export * from "./ThankYouDemo.vue?vue&type=script&lang=ts&"
import style0 from "./ThankYouDemo.vue?vue&type=style&index=0&id=2b946c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b946c4f",
  null
  
)

export default component.exports